import { __module as js } from '../../../../_virtual/index64.js';
import { __require as requireInputRange } from './input-range/input-range.js';

var hasRequiredJs;

function requireJs () {
	if (hasRequiredJs) return js.exports;
	hasRequiredJs = 1;
	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});

		var _inputRange = requireInputRange();

		var _inputRange2 = _interopRequireDefault(_inputRange);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/**
		 * @ignore
		 * @typedef {Object} ClientRect
		 * @property {number} height
		 * @property {number} left
		 * @property {number} top
		 * @property {number} width
		 */

		/**
		 * @typedef {Object} InputRangeClassNames
		 * @property {string} activeTrack
		 * @property {string} disabledInputRange
		 * @property {string} inputRange
		 * @property {string} labelContainer
		 * @property {string} maxLabel
		 * @property {string} minLabel
		 * @property {string} slider
		 * @property {string} sliderContainer
		 * @property {string} track
		 * @property {string} valueLabel
		 */

		/**
		 * @typedef {Function} LabelFormatter
		 * @param {number} value
		 * @param {string} type
		 * @return {string}
		 */

		/**
		 * @ignore
		 * @typedef {Object} Point
		 * @property {number} x
		 * @property {number} y
		 */

		/**
		 * @typedef {Object} Range
		 * @property {number} min - Min value
		 * @property {number} max - Max value
		 */

		exports.default = _inputRange2.default;
		module.exports = exports['default'];
		
	} (js, js.exports));
	return js.exports;
}

export { requireJs as __require };
